module.exports = {
  menu: {
    home: '首頁',
    game: '遊戲',
    connect_login: '連接錢包/登陸',
    new_game: '進入遊戲',
    invite_friends: '邀請好友',
    cms_login: 'CMS登入',
    register: '註冊',
    login: '登入',
    logout: '登出',
    login_to_play_game: '登入以進行遊戲',
    select_login_method: '請選擇登入方式',
    select_register_method: '請選擇註冊方式',
    email: '電子郵件',
    meta_mask: 'MetaMask',
    player_login: '玩家登入',
    history: '戰績',
    transaction_history: '交易記錄',
    ranking: '排行榜',
    purchase: '充值',
    search_game_placeholder: '搜索遊戲..',
    new_games: '新遊戲',
    frequent: '常玩遊戲',
    faq: '常問問題',
    terms_and_conditions: 'Win4Poker 撲克條款與條件',
    tnc: '條款和條件',
    about_us: '關於我們',
    contact_us: '聯絡我們',
    settings: '設置',
    lucky_draw: '幸運抽獎',
    tournament: '錦標賽',
    announcement: '公告',
    no_news: '沒有消息',
    online: '在線',
    deposit: '入金',
    terms_1_title: '參賽資格',
    terms_1_content: '所有玩家必須年滿18歲，並且在法律允許的地區進行註冊和遊戲。',
    terms_2_title: '帳戶註冊',
    terms_2_content: '玩家需通過官方網站註冊帳戶。',
    terms_3_title: '遊戲規則',
    terms_3_content: '所有遊戲必須遵循標準撲克規則，任何作弊行為將導致帳戶被暫停或關閉。',
    terms_4_title: '存款與提款',
    terms_4_content: '玩家必須使用本平台支付方式進行存款，提款將根據平台的處理時間進行。',
    terms_5_title: '獎金分配',
    terms_5_content: '獎金將根據遊戲結果進行分配，具體規則將在遊戲開始前說明。',
    terms_6_title: '責任限制',
    terms_6_content: '平台不對使用任何服務或產品時產生的損失或傷害負責。',
    terms_7_title: '隱私保護',
    terms_7_content: '玩家個人信息將受到保密，僅用於帳戶管理和遊戲目的。',
    terms_8_title: '條款修改',
    terms_8_content: '平台保留隨時修改條款和條件的權利，修改將通過電子郵件或網站公告通知玩家。',
  },
  common: {
    theme: '基礎項目後台',
    delete_record_confirm_msg: '確認刪除？',
    yes: '是',
    no: '否',
    true: '是',
    false: '否',
    success: '成功',
    loading: '載入中',
    or: '或',
    delete: '刪除',
    login: '登入',
    submit: '提交',
    apply: '套用',
    cancel: '取消',
    confirm: '確認',
    back_to_lobby: '返回大廳',
    email: '電郵',
    id_document: '身分證明文件',
    all_in_game: '全押式棄牌德州撲克',
    all_in_game_omaha: '全押式棄牌奧馬哈',
    regular: '德州撲克',
    regular_description: '德州撲克是以無限下注進行的',
    short: '短牌',
    short_description: '短牌德州撲克是用36張牌進行的',
    omaha: '奧馬哈',
    omaha_description: '玩家必須使用兩張底牌來組成手牌',
    regular_allin: '全押式棄牌德州撲克',
    omaha_allin: '全押式棄牌奧馬哈',
    tournament: '錦標賽',
    start: '開桌',
    game_demo_area: '遊戲體驗區',
    total_win_prize: '總贏獎金',
    waiting_list_order: '等候名單順序',
    join_more_than_4_room_error: '無法加入超過4個房間',
    system_message: '系統消息',
    error: '錯誤',
    register: '註冊',
    meta_mask: 'MetaMask',
    wallet_connect: 'Wallet Connect',
    password: '密碼',
    next_step: '下一步',
    next: '下一步',
    verify: '驗證',
    copy_success: '已成功複製',
    enabled: '已啟用',
    enable: '啟用',
    disable: '禁用',
    done: '完成',
    feature_in_progress: '推薦功能開發中，請稍後再查看。',
    no_data: '暫無數據',
    date: '日期',
    retry: '重試',
    location_restricted_title: '地區限制',
    location_restricted_content:
      '您所在的地區目前受到限制。部分功能或服務可能無法使用。感謝您的理解。',
    dont_show_again: '不再顯示',
    edit: '編輯',
    i_am_not_located_in_the_restricted_country: '我不在受限制的國家',
  },
  auth: {
    nickname: '暱稱',
    connect_to_win_4_poker: '連接至WIN 4 POKER',
    wallet_connect_need_to_connect_ur_wallet: '應用程式需要連接你的錢包',
    wallet_connect_sign_this_message:
      '請返回錢包以簽署此訊息以證明你擁有此錢包並繼續。取消將斷開連接。',
    sign_request_in_wallet: '在錢包中簽署請求',
    sign_message_success: '簽署成功',
    cancel: '取消',
    sign: '簽署',
    confirm_password: '確認密碼',
    referral_code: '推薦碼',
    i_have_read_the_agreement: '我已閱讀協議',
    should_accept_agreement: '請接受協議',
    alphabet_validation: '至少包含一個字母字符',
    numeric_validation: '至少包含一個數字',
    length_validation: '至少8個字符，但不超過20個字符',
    placeholder: {
      enter_user_name: '輸入用戶名',
      enter_email: '輸入電子郵件',
      enter_password: '輸入密碼',
      confirm_password: '確認密碼',
      enter_referral_code: '輸入推薦碼',
    },
    error_messages: {
      nickname: '請輸入您的暱稱',
      email_invalid: '這是一個無效的電子郵件',
      email_required: '請輸入您的電子郵件',
      password_required: '請輸入您的密碼',
      password_confirm_required: '請確認您的密碼',
      password_confirm_not_matched: '您輸入的兩個密碼不匹配！',
      incorrect_email_or_password: '電子郵件或密碼不正確',
      error_occurred: '發生錯誤，請稍後再試',
      missing_player_token: '缺少玩家憑證',
      please_try_again: '請再試一次',
    },

    // login-email page
    forget_password: '忘記密碼？',

    // forgot-password page
    forgot_password_title: '忘記密碼',
    please_enter_email_registered: '請輸入您註冊的電子郵件',

    // email-verification page
    email_verification: '電子郵件驗證',
    email_has_been_sent_to: '電子郵件已發送至{{value}}',
    email_resend_countdown_message:
      '未收到電子郵件？您可以在<0>倒數計時</0>秒後再次請求發送電子郵件',
    please_check_your_email: '請檢查您的電子郵件',
    waiting_to_verify_email: '正在驗證您的電子郵件',
    agree_terms_and_privacy: '如果您繼續此程序，即表示您已同意我們的<0>條款</0>和<1>隱私政策</1>。',
    terms: '條款',
    privacy_policy: '隱私政策',

    // metamask-complete-registration page
    complete_metamask_registration: '完成MetaMask註冊',

    // reset-password page
    reset_password: '重設密碼',
    you_may_now_reset_password: '你現在可以為你的帳戶重設密碼。',

    register_an_account: '還沒有帳戶？在此處<0>註冊</0>！',
    resend_code_message: '未收到電子郵件？點擊此處<0>重新發送</0>',

    // 2FA setup page
    two_fa_via_email_title: '透過電郵進行雙重驗證',
    otp_has_been_sent_to_email: '一次性驗證碼已經發送到您註冊的電郵地址。',
    two_factor_authentication: '雙重認證',
    scan_this_qr_code_msg:
      '要設置雙重身份驗證(2FA),請用Authy或Google Authenticator等應用程式掃描此二維碼。',
    choose_scan_qr_code_msg: '打開認證應用程式,點擊右下角的+圖標。選擇掃描二維碼。',
    choose_enter_setup_key_msg: '打開認證應用程式,點擊右下角的+圖標。選擇輸入設置密鑰。',
    secret_key: '密鑰',
    enter_code_in_authenticator_app: '請在認證應用程式中輸入顯示的代碼。',
    two_fa_is_set: {
      title: '2FA已設置',
      message: '您已設置2FA,取款功能現已可用。',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function: '完成電郵驗證以解鎖XXX功能',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '完成身分認證以提升提取金額至100,000 USDT',
    connect_wallet_to_spin: '連接錢包以進行抽獎',

    // enter code page
    link_email: '連接電郵',
    unlink_email: '取消連接電郵',
    expires_in: '將在<0>分鐘</0>後過期',
    resend_code: '<0>重新發送代碼</0>',
    enter_code: '輸入代碼',
    unlink_email_confirm_msg: '你確定要取消連接你的電郵嗎？',
    link_success: '電郵連接成功',
    unlink_success: '電郵取消連接成功',
  },
  slider: {
    about: '關於',
    support: '支持',
  },
  game_room: {
    confirm_leave_msg: '是否確定離開遊戲?',
    join_room_error_title: '加入房間錯誤',
    join_room_error_msg: '加入房間失敗，請重試',
    confirm_withdraw_extra_bet_msg: '是否確定提取額外籌碼',
    total_won_prize: '合共赢得: ${{val, number}}',
    your_balance: '餘額: ${{val, number}}',
    no_enough_balance: '餘額低於最低買入籌碼: ${{val, number}}',
    cash_out: '收取金幣並離開',
    continue_game: '繼續遊戲',
    remark_placeholder: '備註',
    leave_seat: '離開座位',
    sit_in: '回到座位',
    buy_in: '買入',
    buy_in_min_amount: '最低',
    buy_in_max_amount: '最高',
    seconds: '秒',
    close_drawer: '關閉',
    leave_game: '離開遊戲',
    back_to_lobby: '返回大廳',
    leave_table: '離開桌子',
    you_have_copied_room_code: '你已複製房間邀請碼: {{value}}',
    invitation_message:
      '立即進入{{playerName}}創建的遊戲房間！ 房間邀請碼 {{roomNumber}}，開始遊戲吧！',
    link_copied: '你已成功複製連結',
    please_wait_until_connected: '請等待連接',
    rejoin_room: '返回房間',
    theme_setting: '主題設定',
    room_code_share: '複製房間邀請碼',
    room_link_copy: '分享連結',
    table_setting: '牌桌設定',
    emoji_menu: '表情貼圖菜單',
    history_drawer: '房間歷史',
    deposit: '入金',
    withdraw_extra_bet: '提取額外籌碼',
    add_extra_bet: '補充額外籌碼',
    unit_convert: '單位變更',
    silent_mode_on: '靜音模式: 開',
    silent_mode_off: '靜音模式: 關閉',
    raise_to: '加注至',
    winner: '贏家',
    player_status: {
      disconnected: '離線',
      sat_out: '留位離座',
    },
    win_percentage: '勝率',
    all_in: '全押',
    ping_popup_msg: '網絡訊號異常，正在嘗試重新連接中',
    ping_popup_title: '網絡訊號異常',
    ping_popup_content: '正在嘗試重新連接中，可以嘗試刷新頁面',
    disconnected_modal_title: '網絡訊號異常',
    afk_timer_text: '因為你長時間沒有響應，你已被請離座位。若限時內不回桌，你將被請出房間',
    regular: '德州撲克',
    short: '短牌',
    omaha: '奧馬哈',
    omaha_all_in: '全押式棄牌奧馬哈',
    buyin_option: '買入選項',
    buy_in_amount: '買入金額',
    reminder: '提醒',
    not_enough_balance_to_buy_in: '沒有足夠金額買入。',
    sitting_out: '留位離座',
    not_leaving_temporarily: '暫不退出',
    back_to_home: '退出到主頁面',
    are_you_sure_leave_table: '你是擁有最高下注的玩家，確定要退出嗎？',
    leave_table_with_highest_bet_error: '你是擁有最高下注的玩家，無法離開牌桌。請稍後再試',
    loading_room_data: '正在加載房間數據...',
    sit_out_tournament_warning: {
      title: '比賽留座警告',
      msg: '你現在正在參加比賽。如果選擇留座，你仍然需要支付盲注。',
    },
  },
  player_action: {
    bet: '下注',
    call: '跟注',
    check: '過牌',
    raise: '加注',
    fold: '棄牌',
    bb: '大盲',
    sb: '小盲',
    ante: '前注',
    all_in: '全押',
    insurance_cancel: '取消保險',
    insurance_buy: '確認保險',
  },
  game_demo: {
    experience_progress: '體驗碼完成進度',
    game_experience_zone: '遊戲體驗區',
    action_to_redemption: '達成30場有效遊戲兑换現金碼',
    remaining_game_experience_code: '尚欠{{val, number}}個',
    cash_code_exchange: '現金碼兑換',
    successfully_finish_30_games: '已成功完成',
    congrats: '恭喜你！',
    successful_exchange_cash_code: '成功換取{{amount}}現金碼',
    how_to_redeem: '體驗碼如何兑换現金碼',
    successful_condition_of_redemption: '條件:達成30場有效遊戲',
    two_to_three_players: '2-3人場',
    explanation_of_valid_game: '達到10BB & endgame 自己要開牌， 方計算作一場有效',
    more_than_four_players: '4人或以上場',
  },
  userProfile: {
    profile_settings: '檔案設定',
    initial_setting_title: '歡迎來到 Win4.Poker',
    initial_setting_description: '請完成以下初始設置，並享受我們的遊戲',
    display_name: '玩家名稱',
    profile_picture: '玩家頭像',
    edit: '編輯',
    balance: '餘額',
    coin: 'USD',
    demo_coin: '現金體驗碼',
    diamond: '鑽石',
    game_record: '遊戲紀錄',
    ranking_list: '排行榜',
    game_review: '遊戲重溫',
    shortcut_setting: '捷徑設定',
    user_name: '用户名稱:',
    recommend_code: '推薦碼',
    upload_image_msg: '將圖像拖到此處，或',
    upload_image_browser_msg: '瀏覽器',
    upload_image_file_size: '(File Size Max: 68px*93px)',
    username_length_message: '用戶名長度應介於 3-24之間',
    chinese_username_length_message: '包含中文字符的用戶名長度應介於1-5之間',
    username_char_message: "用戶名只可包含字母、數字、中文字符及'_'/'-'/'.'",
    personal_information: '個人資料',
    user_icon: '用戶頭像:',
    save: '儲存',
    my_profile: '我的檔案',
    my_balance: '我的餘額',
    deposit_withdraw: '入金/出金',
    my_record: '我的記錄',
    flow_record: '流水記錄',
    total_earnings: '總收益',
    country: '國家',
    events: '活動',
    disclaimer: '免責聲明',
  },
  maintenance: {
    title: '網站正在維護中',
    content: '我們正努力改善用戶體驗。我們很快就會回來。感謝您的耐心等待。',
  },
  useSetting: {
    card_front: '牌正面',
    card_back: '牌背面',
    table: '桌子',
    add_token_msg: '是否需要入更多代幣?',
  },
  lucky_draw: {
    award_history: '獎勵記錄',
    lucky_draw_rules: '規則',
    remaining_lucky_draw_amount: '剩餘次數：{{value}}',
    remaining_lucky_draw_amount_loading_label: '剩餘次數： ',
    spin_wheel_10_times: '轉動十次',
    spin_wheel: '轉動',
    participation_rate: '遊戲參與率：{{count}}',
    coin_loss: '遊戲參與率',
    congrats: '恭喜！',
    you_have_won: '您贏得了${{prize}}',
    collect_prize: '領取獎勵',
    select_category: '選擇抽獎類別：',
    special_combination: '特殊組合：',
    no_history: '未找到抽獎記錄',
    no_data: '無可用數據',
    spin: '轉動',
    fortune_wheel: '幸運輪盤',
    christmas_fortune_wheel: '聖誕幸運輪盤',
    new_year_fortune_wheel: '新年幸運輪盤',
    cny_fortune_wheel: '農曆新年幸運輪盤',
    email_login: '電子郵件登入',
    thank_you: '感謝您',
    miss_msg_1:
      '感謝您參與我們的活動，您已無剩餘次數。您可以參加我們的遊戲來贏取更多獎勵。祝好運！',
    play_now: '立即遊玩',
    win_msg: '您已贏得 <br/> <large>{{prize}}</large> <br /> 並已存於帳戶餘額',
    diamond: '{{value}} 鑽石',
    draw_again_msg:
      '你還有 <yellow>{{numOfDraws}}</yellow> 次抽獎機會。 <clickable>點擊再抽一次</clickable>',
    redeem_now: '立即兌換',

    deposit_more_than_10: '存款超過 $10',
    get_1_free_spin: '獲得1次免費抽獎機會',
    win_10_times: '贏取10次',
  },
  combination: {
    hi_card: '高牌',
    pair: '一對',
    one_pair: '一對',
    two_pairs: '兩對',
    set: '三條',
    three_of_a_kind: '三條',
    straight: '蛇',
    flush: '花',
    fullHouse: '夫佬',
    full_house: '夫佬',
    quad: '四條',
    straight_flush: '同花順',
    royal_flush: '同花大順',
  },
  room_type: {
    public: '公開房',
    private: '私人房',
  },
  forgot_password: {
    reset_password: '重設密碼',
    password: '密碼',
    confirm_password: '確認密碼',
    phone: '電話',
  },
  error: {
    please_confirm: '請確認',
    password_inconsistent: '密碼不一致',
    file_size_limit_error: '上傳文件大小限制為{{size}}',
    please_input: '請輸入{{field}}',
  },
  translation: {
    success: '成功',
  },
  game_list: {
    table: '牌桌',
    random_join_table: '隨機加入牌桌',
    random_join: '隨機加入',
    join: '加入',
    no_room_available: '沒有房間，請稍後再回來。',
    all_game_loaded: '所有遊戲都已加載',
    join_waiting_list: '加入等待名單',
    join_table: '加入牌桌',
    join_observer: '觀戰',
    game_code: '牌桌代碼',
    game_type: '遊戲類型',
    game_limit: '人數上限',
    game_players: '人數',
    game_unit_test: 'Unit Test',
    game_basicBet: 'Basic Bet',
    game_SB: 'SB',
    game_smallBlind: 'Small Blind',
    regular: '德州撲克',
    all_in: '全押式棄牌德州撲克',
    short: '短牌',
    omaha: '奧馬哈',
    omaha_all_in: '全押式棄牌奧馬哈',
    buy_in: '買入',
    tables: '牌桌',
    notice: '提示',
    time_difference_reminder:
      '閣下的系統時間和互聯網時間存在不尋常的差異，這可能會對玩家倒數計時功能產生影響。為確保最佳性能和準確性，敬請您儘早同步系統時間。',
    player_category: '玩家分類',
    blind_category: '盲注分類',
    table_category: '牌桌分類',
    chips: '籌碼',
    player: '玩家',
    waiting: '等候',
    avg_pot: '平均底池',
    flop_rate: '翻牌率',
    hands_per_hour: '每小時手數',
    no_of_hands_played: '總手數',
    win: '贏',
    invested: '投資',
    pot: '底池',
    all_in_regular: '全押式棄牌德州撲克',
    all_in_omaha: '全押式棄牌奧馬哈',
    usd_balance_updated: '餘額已更新至 ${{balance}}',
    new_room: '新牌桌',
    game: '現金局',
    tournament: '錦標賽',
  },
  game_review: {
    my_bets: '我的下注',
    date_range: '日期範圍',
    select_date_range: '選擇日期範圍',
    show_all_dates: '顯示所有日期',
    show_selected_dates: '顯示選定日期',
    no_game_record: '沒有遊戲記錄',
    win_row_message: 'WIN!!',
    lose_row_message: '支出',
    ante: '底注',
    win: '贏',
    lose: '輸',
    main_pot: '主池',
    side_pot: '邊池{{number}}',
  },
  leader_board: {
    rank: '排名',
    name: '名稱',
    win_game: '累計勝場',
    score: '分數',
  },
  home: {
    dont_miss_promotion_msg: '不要錯過他們',
    all_promotions: '所有促銷',
    my_game: '我的遊戲',
    all_games: '所有遊戲',
    claim_first_time_reward_button: '了解',
    first_time_login: '首次登錄遊戲，',
    first_time_reward_msg: '你會得到{{val}}枚體驗幣',
    open_table: '開桌',
    open_new_room: '開設新房間',
    enter_room_number: '輸入房間編碼',
    start: '開桌',
    enter_code: '輸入提取碼',
    confirm: '確認',
    game_selection: '遊戲選擇',
    start_game: '開桌/入房',
    game_record: '遊戲記錄',
    join_private_room: '私人房約局',
    roomCode: '房間編碼',
    please_enter_a_valid_room_code: '請輸入有效提取碼',
    notice: '提示',
    time_difference_reminder:
      '閣下的系統時間和互聯網時間存在異常差異，可能會影響玩家倒數計時功能，請盡早同步系統時間。如已同步，請重新整理頁面。',
    register_success: '註冊成功',
    referral_code: '推薦碼',
    referral_code_placeholder: '輸入推薦碼',
    display_name: '顯示名稱',
    display_name_placeholder: '輸入顯示名稱',
    user: '玩家',
    bet_amount: '下注金額',
    date: '日期',
    multiplier: '倍數',
    payout: '獎金',
    free_game: '免費遊戲',
    play_without_money: '無需金錢遊玩',
    private_game: '私人房',
    play_with_friends: '與朋友一起玩',
    regular_content: '常規德州撲克採用無限注玩法',
    all_in_content: 'All-In 或 Fold 德州撲克採用無限注玩法',
    short_content: '短牌德州撲克採用無限注玩法',
    omaha_content: '底池限注奧馬哈採用無限注玩法',
    omaha_all_in_content: 'All-In 或 Fold 奧馬哈採用無限注玩法',
    player_statistics: '玩家現況',
    lucky_draw_reminder: {
      title: '提示',
      message: '您還有 {{value}} 次抽獎機會',
      go_to_lucky_draw: '前往抽獎',
      spin_now: '立即轉動',
    },
  },
  disclaimer: {
    title: '免責聲明',
    message: '如果您居住在以下受限制的地區,您不允許在win4.poker上進行遊戲',
    countryList:
      '美國, 土耳其, 阿魯巴, 博內爾, 庫拉索, 法國, 荷蘭, 瑞典, 以色列, 立陶宛, 斯洛伐克, 比利時, 瑞士, 薩巴, 聖尤斯特斯, 聖馬丁, 中國, 英國.',
    checkbox_message: '我確認賭博並不被我所在地的當局禁止,且我年滿18歲。',
    required_message: '請同意免責聲明',
  },
  login: {
    user_account: '用戶名稱',
    password: '密碼',
    cash_web_login: '現金網用戶登入',
    player_register: '玩家註冊',
    gateway_user_name: 'Gateway 用戶名',
    cms_login: 'CMS登入',
    deposit: '入錢',
    deposit_amount: '入錢金額',
    deposit_message: '需要填寫入錢金額',
    notice: '提示',
    duplicate_login: '檢測到相同IP登錄',
    redirecting: '您的頁面將會很快載入，謝謝您的耐心等待。',
    loading: '正在載入資源，請稍候...',
  },
  verification: {
    email_verification_code: '電郵驗證碼',
    email_not_verify_error: '電郵未驗證',
    confirm: '確認',
    timer_count: '計時器計時',
    resend_verification_code: '重新發送驗證碼',
    send_verification_code: '發送驗證碼',
    input_field: '輸入{{field}}',
    code: '代碼',
    successful_verify: '成功驗證',
    two_factor_authentication: '雙重認證',
    verification: '驗證',

    // KYC page
    verify: '身份驗證',
    security: '安全',

    kyc_status: {
      failed_verify_again: '驗證失敗，重試',
      under_review: '正在驗證',
      verify_now: '立即驗證',
    },

    complete_email_verification_to_unlock_some_function: '完成電郵驗證以解鎖XXX功能',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '完成身分認證以提升提取金額至100,000 USDT',
    requirement: '要求',
    verify_now: '立即驗證',

    verification_code: '驗證碼',
    email_verification: {
      title: '電子郵件驗證',
      msg: '請輸入可接收驗證碼的電子郵件地址。',
      otp_has_been_sent_to: '驗證碼已發送到{{value}}',
    },

    id_card: '身分證',
    passport: '護照',

    identity_verification: {
      title: '身份驗證',
      msg: '請使用有效的身份證明文件進行身份驗證。',
      issuing_country: {title: '選擇文件簽發國家', placeholder: '選擇國家'},
      document_type: {
        title: '選擇身份證明文件類型',
        placeholder: '選擇身份證明文件類型',
      },
    },

    uploadDocument: {
      title: '上傳文件',
      make_sure_that_your: '請確保您的文件:',
      is_clear_and_easy_to_read: '清晰且易於閱讀',
      is_unedited: '未經編輯',
      the_whole_doc_must_appear_in_photo: '整份文件都出現在照片中',
      no_reflective_glare: '沒有反射光影',

      upload_image: '上傳照片',
      upload_image_requirement: '文件大小必須小於10MB，支持jpeg或png格式。',
      front_side_of_id: '身份證正面',
      back_side_of_id: '身份證背面',
      personal_data_page_of_passport: '護照個人資料頁',
      document_uploaded: '文件已上傳',
      id_document_under_review_msg: '您的身份證明文件正在審核中，可能需要1-2個工作日完成驗證。',
    },

    disable_2fa: {
      title: '禁用雙重驗證',
      description: '為了繼續操作，請先輸入身份驗證應用程式提供的驗證碼以驗證您的身份',
      success_message: '您已禁用雙重驗證',
    },

    error_messages: {
      document_upload_required: '請上傳文件',
      selection_required: '請選擇一個選項',
    },
  },
  table_area: {
    pot: '底池',
    waiting_for_other_players: '等待其他人入座...',
    waiting_for_game_start: '等待遊戲開始',
    sixty_sec: '60 秒',
    please_select_emoji_target: '請選擇玩家',
  },
  best_combination: {
    hi_card: '高牌 ({{value}})',
    one_pair: '一對 ({{value}})',
    two_pairs: '兩對 ({{firstPair}}, {{secondPair}})',
    set: '三條 ({{value}})',
    straight: '蛇 (由 {{fromValue}} 至 {{toValue}})',
    flush: '花 ({{value}} 高牌)',
    fullHouse: '夫佬 ({{three_cards}} 以及 {{two_cards}})',
    quad: '四條 ({{value}})',
    straight_flush: '同花順 (由 {{fromValue}} 至 {{toValue}})',
    royal_flush: '同花大順',
  },
  action_buttons: {
    place_bet: '落注',
    all_in: '全押',
    bet: '下注',
    check: '過牌',
    call: '跟注',
    raise: '加注',
    fold: '棄牌',
    pot: '底池',
    confirm: '確認',
    investment: '投資',
    insurance: '保險',
    choosing_cards: '選擇牌',
    outs_number: 'OUTS 數',
    insurance_winning_rate: '勝率',
    odds: '賠率',
    premium: '投保額',
    payout: '獎金',
    call_any: '自動跟注',
    wait_for_blinds: '盲注後加入',
    join_directly: '下一局加入',
    check_or_fold: '過牌 / 棄牌',
    confirm_to_fold: '是否確定棄牌?',
    max: '最大',
    min: '最小',
    force_insurance: '強制保險',
  },
  history_drawer: {
    title: '房間歷史',
    small_blind: '盲注(前注)',
    pre_flop: '翻牌前',
    flop: '翻牌',
    turn: '轉牌',
    river: '河牌',
    no_data: '沒有房間數據',
    hands: '手牌',
    winner: '贏家',
    buy_in: '買入',
    pool: '底池',
    win_player: '勝出玩家',
    time: '時間',
    main_pot: '主池',
    side_pot_one: '邊池 1',
    side_pot_two: '邊池 2',
    side_pot_three: '邊池 3',
    win: '贏',
    loading: '載入中',
    all_record_loaded: '所有房間歷史都已加載',
    previous_page: '上一頁',
    close: '關閉',
    detail: '詳情',
  },
  file_upload: {
    upload: '上傳',
  },
  user_menu: {
    two_factor: '雙重認證',
    change_password: '更改密碼',
    logout: '登出',
    hello_user: '您好',
  },
  change_password_board: {
    change_password: '更改密碼',
    old_password: '舊密碼',
    new_password: '新密碼',
    confirm_password: '確認密碼',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: '搜索..',
    filter: '篩選',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: '讀',
    write: '寫',
    none: '無',
    banned: '禁止',
  },
  phone_input: {
    invalid_country_code: '無效國家代碼',
    invalid_phone: '無效電話',
    phone_number: '電話號碼',
    phone_code: '區號',
  },
  room_setting_drawer: {
    create_new_room: '創建新房間',
    enter_room_code: '輸入房間編碼',
    please_enter_a_valid_room_code: '請輸入有效提取碼',
    please_input_room_code: '請輸入房間編碼',
    enter_room: '輸入房間',
    room_setting: '開房設定',
    small_blind: '盲注:',
    ante: '前注:',
    buy_in: '入注:',
    number_of_people: '人數:',
    action_time: '行動時間:',
    game_duration: '牌局時長:',
    commission: '佣金:',
    insurance: '保險:',
    location_restriction: '地點限制',
    diamond_needed: '所需鑽石:',
    diamond_owned: '現有鑽石:',
    redeem: '購買鑽石',
    open_room: '創建房間',
    maximum: '上限:',
    hours: '{{value}}小時',
    minute: '{{value}}分鐘',
    second: '{{value}}秒',
    affect_diamond_needed: '影響所需礸石',
    remaining_room_time: '房間結束時間尚餘',
    diamond_require: '所需鑽石:',
    time_increase: '增加時間:',
    recharge: '充值',
    isAllIn: '全押',
    ipchecking: 'IP限制',
    diamond_not_enough: '鑽石餘額不足',
  },
  gameRecharge: {
    sticker_title: '貼圖',
    check_for_more: '查看更多',
    diamond_title: '鑽石',
    diamond_product_tag: '{{value}} 鑽石',
    buy_diamond_confirm_msg: '買入確認',
    buy_sticker_confirm_msg: '要購入此表情貼圖嗎?',
    balance_not_enough_msg: '你的餘額不足',
    sticker_product_tag: '需要{{value}}鑽石',
    confirm_to_buy_button: '確認',
    confirm_title: '買入確認',
    confirm_message: '你確認要以 USD$ <0>{{usdAmount}}</0> 買入 <1>{{diamondAmount}} 鑽石</1> 嗎？',
    redeem: '充值',
    confirm: '確認',
    reminder: '提醒',
    not_enough_money: '抱歉，你的餘額不足以購買鑽石。',
    not_enough_diamond: '你的鑽石餘額不足，請先購買鑽石。',
    quanity: '數量:',
    price: '售價:',
    diamond: '鑽石',
    sticker: '表情貼圖',
    purchase_success: '購買成功',
    purchase: '購買',
    diamond_balance: '鑽石餘額',
    free_sticker: '此為免費商品',
    amount_required: '需要填寫數量',
    valid_amount: '請輸入有效數量',
    not_enough_diamond_balance: '鑽石餘額不足',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: '全部',
      usd: 'USD',
      cash: '現金體驗碼',
      diamond: '鑽石',
    },
    transactionType: {
      createRoom: '開私人房間',
      luckyDraw: '玩幸運抽獎',
      purchaseItem: '購買表情貼圖',
      purchaseDiamond: '購買{{value}}顆鑽石',
      joinGame: '參與{{value}}牌局',
      winGame: '贏得{{value}}牌局',
      loseGame: '輸掉{{value}}牌局',
      winGameWithoutGameType: '贏得牌局',
      loseGameWithoutGameType: '輸掉牌局',
      joinGameWithoutGameType: '參與牌局',
      deposit: '充值',
      redeemDemo: '兌換現金碼',
      insurance: '保險',
      gift: '禮物',
      firstLogin: '首次登錄',
      privateRoomRebate: '私人房間回贈',
    },
    transactionRecord: '流水明細',
    no_transaction_record: '無交易記錄',
    currentMonth: '本月',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: '要購入此表情貼圖嗎?',
    sticker_product_tag: '需要{{value}}鑽石',
    confirm_to_buy_button: '確認購買',
    emoji: '表情符號',
    free: '免費',
    no_available_emoji: '沒有可用的表情貼圖',
  },
  playerInfo: {
    button: '莊家',
    smallBlind: '小盲',
    bigBlind: '大盲',
    cutOff: '關位',
    underTheGun: '槍口',
    bet: '下注',
    check: '過牌',
    call: '跟注',
    raise: '加注',
    fold: '棄牌',
    cancelInsurance: '取消\n保險',
    confirmInsurance: '確認\n保險',
    allIn: '全押',
    skip: '跳過',
  },
  deposit_withdraw: {
    currency_usdt: 'Tether (USDT)',
    deposit_method: '存款方式',
    remark: '備註',
    ton_connect: 'TON Connect',
    manual_deposit: '手動存款',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: '入金',
    withdraw: '出金',
    withdrawal: '出金',
    history: '出入金記錄',
    blockchain: '區塊鏈',
    currency: '幣種',
    network: '網絡',
    exchange_rate: '匯率',
    deposit_address: '充值地址',
    deposit_process_message_1: '系统收到款項後會馬上進行入金處理，流程約需兩小時，請耐心等候。',
    back: '返回',
    address: '地址',
    transaction_id: '交易編號',
    amount: '提取數量',
    time: '時間',
    coin_type: '幣種',
    available_amount: '可提取金額',
    withdraw_amount: '提取數量',
    withdraw_cost: '提取費用',
    receiving_amount: '預計收到金額',
    deposit_amount: '入金數量',
    deposit_amount_placeholder: '請輸入入金數量',
    no_data: '暫無數據',
    address_placeholder: '請輸入地址',
    amount_placeholder: '請輸入數量',
    withdrawal_amount: '提取數量',
    withdrawal_fee: '提取費用',
    max: '最大',
    available_cash_out_balance: '可提取餘額',
    cash_out_info: '在參與獎池後，您只能提取在撲克遊戲中贏得的 USDT，或在遊戲平局時提取。',
    wallet_balance: '錢包餘額',
    deposit_pending_title: '入金待處理',
    deposit_pending_description: '您的入金目前正在等待批准',
    deposit_success_title: '入金成功',
    deposit_success_description: '資金已存入您的帳戶',
    create_withdraw_success_title: '出金請求成功',
    create_withdraw_success_description: '您的提現請求正在處理中',
    withdrawal_success_title: '出金成功',
    withdrawal_success_description: '您的提現請求已完成',
    amount_required: '需要填寫金額',
    amount_exceeds_available: '金額超過可用餘額',
    amount_below_minimum: '金額低於最低限額',
    amount_below_fee: '金額低於手續費',
    invalid_number: '無效的數字',
    network_required: '需要選擇網路',
    address_required: '需要填寫地址',
    blockchain_required: '需要選擇區塊鏈',
    email_required: '需要填寫電子郵件',
    valid_amount: '請輸入有效的金額',
    notice: '提示',
    cancel: '取消',
    cancel_transaction: '您已取消交易',

    from: '來自',
    receive_amount: '收取金額',

    // 2FA
    two_fa_required_msg: '為了安全起見，在取款之前必須設置雙重認證。',
    setup_2fa: '設置雙重認證',
    lost_my_2fa_access: '遺失了雙重認證',

    wallets_usdt_token: '錢包的USDT代幣',
    memo_reminder_1: '請確保在備註欄中輸入 {{memo}}，否則我們的系統無法將資金存入您的帳戶。',
    memo_reminder_2: '如果使用 TonConnect，系統將自動填寫。',

    wait_for_next_lucky_draw: '請等待下一次幸運抽獎活動，以獲取遊戲資金的機會。',
  },
  history_status: {
    completed: '完成',
    pending: '處理中',
  },
  transaction_history: {
    tab_titles: {
      all_flow: '所有流水',
      deposits: '存款',
      withdrawals: '提款',
      bets: '投注',
      purchase: '購買鑽石',
      diamond: '鑽石',
    },
    transaction_type: '交易類型',
    transaction_types: {
      deposits: '存款',
      withdrawals: '提款',
      bets: '投注',
      purchase: '購買鑽石',
      diamond: '鑽石',
      purchase_item: '鑽石交易',
      referral_commission: '推薦佣金',
      payout: '獎金',
      private_room: '開設私房',
      private_room_rebate: '私房反水',
      reward: '獎賞',
      lucky_draw: '幸運抽獎',
      tournament_ticket_fee: '錦標賽門票費',
      tournament_prize: '錦標賽獎金',
    },
    game_type: '遊戲類型',
    type: '類型',
    bet: '投注',
    payout: '獎金',
    amount: '金額',
    quantity: '數量',
    balance: '餘額',
    diamond: '鑽石',
    sticker: '貼紙',
  },
  referral: {
    referral: '推薦',
    invite_friends_description: '邀請朋友加入Win4Poker，獲得獎勵',
    whatsapp_referral_message:
      '你準備好要贏牌了嗎？🃏 來和我一起在Win4Poker享受精彩對局吧！ 這是我的邀請連結： ',
    number_of_referrals: '推薦人數',
    referral_rewards: '推薦獎勵',
    my_commission: '我的佣金',
    referral_code: '推薦碼',
    referral_link: '推薦鏈接',
    enter_code: '輸入代碼',
    terms_and_conditions: 'Win4Poker條款和條件',
    invite_friends: '邀請朋友',
    pop_up_title: '提示',
    back_home: '返回主頁',
    scan_qr_code: '掃描二維碼',
    code: '代碼',
    copy_link: '複製鏈接',
    save_image: '保存圖片',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: '更多',
    referral_history: '推薦記錄',
    register_time: '註冊時間',
    player: '玩家',
    reward_time: '獎勵時間',
    reward_amount: '獎勵金額',
    referral_list: '推薦列表',
    enter: '輸入',
    skip: '跳過',
    please_input_referral_code: '請輸入推薦碼',
    enter_referral_code: '輸入推薦碼',
    enter_referral_code_success: '輸入推薦碼成功',
    cannot_use_own_referral_code: '不能使用自己的推薦碼',
    total: '總計',
    referral_code_invalid: '推薦碼無效',
    commission: '佣金',
    reward_type: '獎勵類型',
    amount: '金額',
    commission_reward: '佣金獎勵',
    commission_update_success: '佣金更新成功',
    commission_setting: '佣金設定',
    save: '儲存',

    // title
    promotion_1: '推薦 1：存款獎金',
    promotion_2: '推薦 2：推薦代碼獎勵',
    general_terms: '一般條款和條件',

    // sub-title
    eligibility: '資格',
    offer: '優惠',
    conditions: '條件',
    program_duration: '計劃時長',
    account_verification: '帳戶驗證',
    limitations: '限制',
    modification_of_terms: '條款修改',
    compliance: '合規',
    support: '支持',

    error_messages: {
      referral_code_invalid: '推薦碼必須為4至8個字符長，只能包含字母數字字符，排除「I」和「O」。',
      referral_code_required: '請輸入推薦碼',
    },

    // points
    eligibility_1: '用戶必須在其 Win4Poker 帳戶中存入超過 1 USDT。',
    offer_1: '符合條件的用戶將獲得 1 USDT 的免費禮物，直接存入其帳戶。',
    conditions_1: '此優惠無限制。',
    conditions_2: '存款必須在 Win4Poker 指定的推薦期間內完成。',
    conditions_3: '用戶必須擁有經驗證的帳戶才能符合此推薦條件。',

    eligibility_2: '用戶必須使用其唯一的推薦代碼推薦朋友。',
    offer_2: '當推薦的朋友完成其第一場遊戲時，推薦人將獲得最高彩池總額的 3.5% 作為獎勵。',
    conditions_4: '推薦的朋友必須使用推薦人的代碼註冊。',
    conditions_5: '獎勵將在推薦的朋友完成其遊戲後 2 小時內發放。',
    conditions_6: '用戶可以通過其帳戶儀表板追蹤其推薦和獎勵。',
    program_duration_1: '這些推薦活動將在我們的網站和官方渠道上溝通的指定期間內進行。',
    account_verification_1: '參與者必須擁有完全驗證的帳戶才能符合任何獎勵資格。',
    limitations_1: '被發現濫用推薦系統（例如自我推薦）的用戶，其帳戶可能會被暫停或禁用。',
    modification_of_terms_1: 'Win4Poker 保留隨時修改或終止這些推薦活動的權利，恕不另行通知。',
    compliance_1: '參與者必須遵守其司法管轄區內適用的在線遊戲和推薦相關法律法規。',
    support_1: '如需有關推薦計劃的問題或協助，請聯繫我們的客戶支持團隊。',

    // disclaimer
    disclaimer: '免責聲明',
    disclaimer_1: '所有獎勵均受限於供應情況，並可能根據帳戶狀態和活動有所變化。',
    disclaimer_2: 'Win4Poker 對於可能妨礙成功追蹤推薦或獎勵的任何技術問題不承擔責任。',

    commission_calculation: {
      title: '佣金計算',
      first_layer: '第一層 %',
      second_layer: '第二層 %',
      third_layer: '第三層 %',
      refers: '推薦',
      referrer: '推薦人',
      content:
        '獲勝者獎金的5%會被扣除作為佣金。網關<0>最多</0>獲得佣金的30%。網關將剩餘70%的佣金分配給最高級別的推薦人，該推薦人可以決定將70%佣金的Z%分配給下一級別的推薦人。下一級別的推薦人可以決定將Z%佣金的Y%分配給下一級別，這個過程會持續到佣金到達獲勝者的推薦人。',
      example: {
        title: '例子：',
        winner_wins: '獲勝者獎金：${{value}}',
        total_commission: '總佣金：${{value}}',
        gateway_total_commission_max: '網關總佣金（最高）：${{value}}',
        referral_total_commission_min: '推薦總佣金（最低）：${{value}}',

        referral_commissions: '推薦佣金（70 ≥ Z ≥ Y ≥ X ...）：',
        referrer_1_commission: '推薦人 1：${{totalCommission}} ×（Z% - Y%）',
        referrer_2_commission: '推薦人 2：${{totalCommission}} ×（Y% - X%）',
        referrer_3_commission: '推薦人 3：${{totalCommission}} × X%',
      },
    },

    fixed_commission: '固定佣金',
    custom_commission: '自定義佣金',
    invalid_commission_percentage: '無效的佣金百分比',
    commission_placeholder: '輸入佣金百分比',
    my_share: '我的佣金',
  },
  ranking: {
    ranking: '排名',
    today: '今日',
    this_week: '本週',
    this_month: '本月',
  },
  tournament: {
    you_have_won: '您贏得了',
    time_elapsed: '已用時間',
    prize_pool: '獎金池',
    entries: '參賽者',
    of: '的',
    congratulations: '恭喜',
    thanks_for_your_joining: '感謝您的參與',
    watch: '觀看',
    see_result: '查看結果',
    view_tournament: '查看比賽',
    deregister: '取消註冊',
    start_in: '<0>countdown</0>後開始',
    full: '已滿',
    register_end_in: '註冊將在<0>countdown</0>後結束',
    my_ranking: '我的排名',
    players: '玩家',
    register: '註冊',
    pay_for_registration: '支付 {{ticketFee}} 進行註冊',
    register_confirmation_message:
      '註冊此比賽需支付 {{ticketFee}} 的票費，您確定要註冊參加 {{tournamentName}} 嗎？',
    late_register: '延遲註冊',
    level: '級別',
    blinds: '盲注 (小盲/大盲)',
    ante: '前注',
    duration: '持續時間',
    game_rule: '遊戲規則',
    game_mode: '遊戲模式',
    speed: '速度',
    general_information: '基本信息',
    ticket_fee: '門票費',
    starting_stack: '起始籌碼',
    blinds_start: '盲注開始',
    ante_starts: '前注開始',
    raised_every: '每隔多久提高',
    minutes: '分鐘',
    prize: '獎金',
    structure: '結構',
    gameModeTitle: {
      classic: '經典',
      turbo: '快速',
      hyper: '超快',
    },
    gameModeDescription: {
      classic: '經典多桌比賽，參賽者競爭贏取總獎金池的份額。',
    },
    speedTitle: {
      regular: '普通',
      turbo: '快速',
      hyper: '超快',
    },
    speedDescription: '盲注每{{value}}分鐘增加',
    tournament: '比賽',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    results: '結果',
    on_going: '進行中',
    title: '比賽詳情',
    tables: '桌子',
    minutes_short: '分鐘',
    current_blinds: '當前盲注',
    next_blind_at: '下一個盲注',
    start_game_in: '開始於',
    no_tournaments_available: '沒有可用的比賽',
    you_have_not_participated_in_any_tournament_yet: '您尚未參加任何錦標賽',
    tournament_started: '錦標賽已開始',
    tournament_ended_msg: '錦標賽已結束',
    tournament_canceled_msg: '錦標賽已取消',
    view_table: '查看牌桌',
    view_player_table: '查看玩家牌桌',
    table_rebalancing: '牌桌重新平衡',
    upcoming: '即將開始',
    in_progress: '進行中',
    finished: '已結束',
    waiting_enough_players_to_start: '等待足夠的玩家開始',
    cancelled: '已取消',
    too_many_rooms_description:
      '{{tournamentName}} 即將開始，但您已達到最大桌子數量，請離開以下至少1個桌子以加入 {{tournamentName}}。',
    leave: '離開',
    sit_in: '加入 {{name}}',
    ignore: '忽略',

    re_entry_modal: {
      title: '重新進入錦標賽？',
      description:
        '{{tournamentName}} 仍然可以加入，您想花費 ${{ticketFee}} 的門票費重新參加比賽嗎？',
      re_enter: '重新進入',
      view_tournament: '查看比賽',
    },
    waiting_for_players: {
      title: '等待玩家',
      message: '等待 {{count}} 位玩家加入',
      message_plural: '等待 {{count}} 位玩家加入',
    },
    thanks_for_joining: {
      title: '感謝參加！',
      description: '感謝您參加 {{tournamentName}}。比賽仍在進行中，您稍後可以查看您的結果。',
      view_results: '查看比賽結果',
    },
    cancel: {
      title: '錦標賽已取消',
      description: '錦標賽「{{tournamentName}}」已被取消。',
      refund_message: '您的報名費 ${{amount}} 將會退還。',
      confirm: '確定',
    },
    waiting_timer: {
      title: '等待玩家',
      cancel_in: '取消倒數',
    },
  },
  errorCodes: {
    default: {
      title: '系統錯誤',
      message: '發生了問題，請稍後再試',
    },

    WS_0000: '系統錯誤',
    WS_0001: '不可進入超過4間房間',
    WS_0002: '不可在下注最多賭注時離開',
    WS_0003: '驗證錯誤，請刷新頁面再試一次',
    WS_0004: '偵測到房間內有附近的人，因此暫時不能進入該房間',
    WS_0005: '不能退出擁有最高下注的玩家。請先棄牌',
    WS_0006: '買入錯誤',
    WS_0007: '房間不存在',

    HP_0001: '不可進入超過4間房間',
    HP_0002: '目前無法連接伺服器，請稍後再試。',
    HP_0003: '買入金額不足',
    HP_0004: '無效的驗證碼',
    INVALID_EMAIL_PASS_CODE: '無效的驗證碼',
    INVALID_OTP: '無效的驗證碼',
    INVALID_REFERRAL_CODE: '無效的推薦碼',
    REFERRAL_CODE_ALREADY_USED: '推薦碼已經被使用',
    INSUFFICIENT_COINS: '錢包餘額不足',
    JOIN_TOURNAMENT_ERROR: '加入錦標賽錯誤',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: '位置存取被拒絕。',
      POSITION_UNAVAILABLE: '位置信息不可用。請稍後再試。',
      TIMEOUT: '獲取您的位置請求超時。請再試一次。',
      UNKNOWN: '請求您的位置時發生未知錯誤。',
    },
    TOURNAMENT_IS_FINISHED: '錦標賽已結束',
    GPS_RESTRICTION: '無法偵測位置或您附近的玩家已加入同一個房間，請稍後再試',
  },
};
